import styled from 'styled-components';

import JourneyList from './component';

export default styled(JourneyList)`
  padding-bottom: ${(props) => props.theme.base.gridSizes.L};
`;
